/**
 * Écrans hors jeu : accueil (jouer en invité, se connecter, créer un compte)
 * et chargement. Surface « neige » du concept, titre en Marcellus.
 */
import { useState } from 'preact/hooks';
import { Button } from './components';
import { login, playAsGuest, register, type Account } from '../auth';

export function LoginScreen(props: { onReady: (s: { token: string; account: Account }) => void }) {
  const [tab, setTab] = useState<'guest' | 'login' | 'register'>('guest');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const run = async (fn: () => Promise<{ token: string; account: Account }>) => {
    setBusy(true);
    setError('');
    try {
      props.onReady(await fn());
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Erreur inconnue');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div class="kh-screen">
      <form
        class="kh-screen-card"
        onSubmit={(e) => {
          e.preventDefault();
          if (tab === 'guest') void run(() => playAsGuest(name || undefined));
          else if (tab === 'login') void run(() => login(name, password));
          else void run(() => register(name, password));
        }}
      >
        <h1>SnowChain</h1>
        <p>Gérez votre station de ski dans une vallée partagée. Chaque décision compte pour l'écosystème du serveur.</p>
        <div class="kh-tabs" style={{ padding: 0 }}>
          <button type="button" class={tab === 'guest' ? 'on' : ''} onClick={() => setTab('guest')}>
            Invité
          </button>
          <button type="button" class={tab === 'login' ? 'on' : ''} onClick={() => setTab('login')}>
            Se connecter
          </button>
          <button type="button" class={tab === 'register' ? 'on' : ''} onClick={() => setTab('register')}>
            Créer un compte
          </button>
        </div>
        <label for="sc-name">{tab === 'guest' ? 'Nom de joueur (facultatif)' : 'Nom de joueur'}</label>
        <input id="sc-name" value={name} maxLength={24} autoComplete="username" onInput={(e) => setName((e.target as HTMLInputElement).value)} />
        {tab !== 'guest' && (
          <>
            <label for="sc-pass">Mot de passe</label>
            <input
              id="sc-pass"
              type="password"
              value={password}
              minLength={8}
              autoComplete={tab === 'login' ? 'current-password' : 'new-password'}
              onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
            />
          </>
        )}
        <div style={{ marginTop: '18px' }}>
          <Button type="submit" size="md" full disabled={busy}>
            {tab === 'guest' ? 'Jouer en invité' : tab === 'login' ? 'Se connecter' : 'Créer le compte et jouer'}
          </Button>
        </div>
        {tab === 'guest' && <p style={{ margin: '10px 0 0' }}>Votre partie est sauvegardée sur le serveur. Vous pourrez protéger ce compte par un mot de passe plus tard.</p>}
        {error && <div class="kh-err">{error}</div>}
      </form>
    </div>
  );
}

export function LoadingScreen(props: { label: string; progress: number }) {
  return (
    <div class="kh-screen">
      <div class="kh-loading">
        <h1>SnowChain</h1>
        <div class="sc-track">
          <div class="sc-fill" style={{ width: `${Math.round(props.progress * 100)}%` }} />
        </div>
        <div class="muted" style={{ color: 'var(--text-inverse)' }}>
          {props.label}
        </div>
      </div>
    </div>
  );
}

export function ErrorScreen(props: { title: string; message: string; onRetry?: () => void }) {
  return (
    <div class="kh-screen">
      <div class="kh-screen-card">
        <h1>{props.title}</h1>
        <p>{props.message}</p>
        {props.onRetry && (
          <Button size="md" onClick={props.onRetry}>
            Réessayer
          </Button>
        )}
      </div>
    </div>
  );
}
